var _g, _text, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeedsApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "needs_approval_status",
    "data-name": "needs approval status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 23,
    viewBox: "0 0 121 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    fill: "#f5f7f4",
    stroke: "#307349",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 23,
    rx: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 120,
    height: 22,
    rx: 4,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Needs_Approval",
    "data-name": "Needs Approval",
    transform: "translate(23 15)",
    fill: "#307349",
    fontSize: 12,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Needs Approval"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_circle_FILL0_wght400_GRAD0_opsz48",
    d: "M85.584,185.53l4.634-4.634-.753-.737-3.881,3.881-1.965-1.965-.737.737Zm.966,3.57a6.338,6.338,0,0,1-2.538-.516,6.6,6.6,0,0,1-3.5-3.5,6.543,6.543,0,0,1,0-5.093,6.546,6.546,0,0,1,1.408-2.08,6.714,6.714,0,0,1,2.088-1.4,6.543,6.543,0,0,1,5.093,0,6.54,6.54,0,0,1,3.48,3.48,6.543,6.543,0,0,1,0,5.093,6.715,6.715,0,0,1-1.4,2.088,6.546,6.546,0,0,1-2.08,1.408A6.378,6.378,0,0,1,86.55,189.1Zm0-.983a5.563,5.563,0,1,0-3.938-1.629A5.357,5.357,0,0,0,86.55,188.118ZM86.55,182.55Z",
    transform: "translate(-74.438 -171.1)",
    fill: "#307349"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedsApproval);
export default __webpack_public_path__ + "static/media/needs_approval.80d0b330441a9f172b59b94dbf81cb88.svg";
export { ForwardRef as ReactComponent };